import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'

import { useReselector, useScrollRef, useTimeoutRef } from '@/utils/sharedHooks'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useAnalyticsTrack, useAnalyticsView } from '@/features/amplitude'

import { Heading, HeadingVariants } from '@/ui'
import { mtc } from '@/styles'
import { styles } from './styles'
import { AccountDetailsCard } from './account-details-card'
import { ConnectedFinancialInstitutionsCard } from './connected-financial-institutions-card'
import { PlansAndBillingCard } from './plans-billing-card'

export const Settings = () => {
  const pageView = useAnalyticsView()
  const track = useAnalyticsTrack()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const { scrollToRef } = useScrollRef()
  const timeoutRef = useTimeoutRef()

  useEffect(() => {
    if (location.hash === '#connected-institutions') {
      // Give the page a little to load so we scroll to the proper spot
      timeoutRef.current = setTimeout(scrollToRef, 500)
    }
  }, [location.hash, scrollToRef, timeoutRef])

  useEffect(() => {
    pageView('account')
  }, [pageView])

  useEffect(() => {
    // Track channel for plaid statement migration
    const plaidStatementSource = searchParams.get('psSrc')
    if (plaidStatementSource) {
      track(`view settings from ${plaidStatementSource}`)
    }
  }, [track, searchParams])

  const currentUser = useReselector(getCurrentUser)
  const isNotAdminOrQA = !currentUser?.admin && !currentUser?.qaDetails

  return (
    <div className={mtc(styles())}>
      <Heading variant={HeadingVariants.H1}>Settings</Heading>
      <AccountDetailsCard />
      <ConnectedFinancialInstitutionsCard />
      {isNotAdminOrQA && <PlansAndBillingCard />}
    </div>
  )
}
